/* unplugin-vue-components disabled */import { render } from "./LogicalTransformerSectorImg.vue?vue&type=template&id=3cb2a41a&scoped=true"
import script from "./LogicalTransformerSectorImg.vue?vue&type=script&lang=js"
export * from "./LogicalTransformerSectorImg.vue?vue&type=script&lang=js"

import "./LogicalTransformerSectorImg.vue?vue&type=style&index=0&id=3cb2a41a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb2a41a"]])

export default __exports__